export default __webpack_public_path__ + "static/Hack-BoldItalic-646b2897432213d7e4e8953f87092913.woff";